var map = {
	"./skins/IBC-dyst-2025": [
		192,
		18
	],
	"./skins/IBC-dyst-2025.css": [
		557,
		39
	],
	"./skins/IBC-dyst-2025.js": [
		192,
		18
	],
	"./skins/aktionaerliga-2024": [
		193,
		17
	],
	"./skins/aktionaerliga-2024.css": [
		558,
		38
	],
	"./skins/aktionaerliga-2024.js": [
		193,
		17
	],
	"./skins/aktionaerliga-2025": [
		194,
		16
	],
	"./skins/aktionaerliga-2025.css": [
		559,
		37
	],
	"./skins/aktionaerliga-2025.js": [
		194,
		16
	],
	"./skins/bibliotekarernes-sep-2024": [
		195,
		15
	],
	"./skins/bibliotekarernes-sep-2024.css": [
		560,
		36
	],
	"./skins/bibliotekarernes-sep-2024.js": [
		195,
		15
	],
	"./skins/boersen-spiel-sep-2024": [
		196,
		14
	],
	"./skins/boersen-spiel-sep-2024.css": [
		561,
		35
	],
	"./skins/boersen-spiel-sep-2024.js": [
		196,
		14
	],
	"./skins/borsgruppenliu-jan-2024": [
		197,
		13
	],
	"./skins/borsgruppenliu-jan-2024.css": [
		562,
		34
	],
	"./skins/borsgruppenliu-jan-2024.js": [
		197,
		13
	],
	"./skins/fynske-bank-sep-2024": [
		198,
		12
	],
	"./skins/fynske-bank-sep-2024.css": [
		563,
		33
	],
	"./skins/fynske-bank-sep-2024.js": [
		198,
		12
	],
	"./skins/ibc-jan-2024": [
		199,
		19
	],
	"./skins/ibc-jan-2024.js": [
		199,
		19
	],
	"./skins/sdu-businessschooldays-2024": [
		200,
		11
	],
	"./skins/sdu-businessschooldays-2024.css": [
		564,
		32
	],
	"./skins/sdu-businessschooldays-2024.js": [
		200,
		11
	],
	"./skins/sdu-businessschooldays-2025": [
		201,
		10
	],
	"./skins/sdu-businessschooldays-2025.css": [
		565,
		31
	],
	"./skins/sdu-businessschooldays-2025.js": [
		201,
		10
	],
	"./skins/skoledyst-oct-2023": [
		202,
		9
	],
	"./skins/skoledyst-oct-2023.css": [
		566,
		30
	],
	"./skins/skoledyst-oct-2023.js": [
		202,
		9
	],
	"./skins/skolernes-aktiedyst-2024": [
		203,
		8
	],
	"./skins/skolernes-aktiedyst-2024.css": [
		567,
		29
	],
	"./skins/skolernes-aktiedyst-2024.js": [
		203,
		8
	],
	"./skins/skolernes-aktiedyst-2025": [
		204,
		7
	],
	"./skins/skolernes-aktiedyst-2025.css": [
		568,
		28
	],
	"./skins/skolernes-aktiedyst-2025.js": [
		204,
		7
	],
	"./skins/sommerdysten-ad-2023": [
		205,
		6
	],
	"./skins/sommerdysten-ad-2023.css": [
		569,
		27
	],
	"./skins/sommerdysten-ad-2023.js": [
		205,
		6
	],
	"./skins/sommerdysten-ak-2023": [
		206,
		5
	],
	"./skins/sommerdysten-ak-2023.css": [
		570,
		26
	],
	"./skins/sommerdysten-ak-2023.js": [
		206,
		5
	],
	"./skins/sommerdysten-is-2023": [
		207,
		4
	],
	"./skins/sommerdysten-is-2023.css": [
		571,
		25
	],
	"./skins/sommerdysten-is-2023.js": [
		207,
		4
	],
	"./skins/sydbank-sep-2020": [
		208,
		3
	],
	"./skins/sydbank-sep-2020.css": [
		572,
		24
	],
	"./skins/sydbank-sep-2020.js": [
		208,
		3
	],
	"./skins/targo-2025": [
		209,
		2
	],
	"./skins/targo-2025.css": [
		573,
		23
	],
	"./skins/targo-2025.js": [
		209,
		2
	],
	"./skins/ung_aktiedyst_2025": [
		210,
		1
	],
	"./skins/ung_aktiedyst_2025.css": [
		574,
		22
	],
	"./skins/ung_aktiedyst_2025.js": [
		210,
		1
	],
	"./skins/ungdomsudddyst-oct-2024": [
		211,
		0
	],
	"./skins/ungdomsudddyst-oct-2024.css": [
		575,
		21
	],
	"./skins/ungdomsudddyst-oct-2024.js": [
		211,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 356;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/dynamic lazy ^\.\/.*$
// module id = 356
// module chunks = 40